<template>
	<div class="pui-form">
		<mgrupoenvasado-modals :modelName="modelName"></mgrupoenvasado-modals>
		<!--<pui-form-header
			v-if="modelLoaded"
			:showHeader="!isCreatingElement">
			<mgrupoenvasado-form-header
				:modelPk="modelPk"
			></mgrupoenvasado-form-header>
		</pui-form-header>-->
		<v-form class="mb-4 pb-4" ref="form" v-model="valid" lazy-validation @submit.prevent v-if="modelLoaded">
			<v-layout wrap class="pui-form-layout">
				<v-flex xs12 md12>
					<pui-field-set :title="getTitleDatos">
						<v-layout wrap>
							<!-- IDTIPRES -->
							<v-flex xs12 md1>
								<pui-text-field
									:id="`idgruenv-mgrupoenvasado`"
									v-model="model.idgruenv"
									:label="$t('mgrupoenvasado.idgruenv')"
									disabled
									toplabel
									maxlength="10"
								></pui-text-field>
							</v-flex>
						</v-layout>
						<v-layout wrap>
							<!-- CODGRUENVEDI -->
							<v-flex xs12 md1>
								<pui-text-field
									:id="`codgruenvedi-mgrupoenvasado`"
									v-model="model.codgruenvedi"
									:label="$t('mgrupoenvasado.codgruenvedi')"
									:disabled="formDisabled"
									required
									toplabel
									maxlength="3"
								></pui-text-field>
							</v-flex>
						</v-layout>
						<v-layout wrap>
							<!-- NAME -->
							<v-flex xs12 md4>
								<pui-text-field
									:id="`name-mgrupoenvasado`"
									v-model="model.name"
									:label="$t('mgrupoenvasado.name')"
									:disabled="formDisabled"
									required
									toplabel
									maxlength="50"
								></pui-text-field>
							</v-flex>
						</v-layout>
						<v-layout wrap>
							<!-- FECBAJA -->
							<v-flex xs12 md3>
								<pui-date-field
									:id="`fecbaja-mgrupoenvasado`"
									v-model="model.fecbaja"
									:label="$t('mgrupoenvasado.fecbaja')"
									:disabled="formDisabled"
									toplabel
									time
								></pui-date-field>
							</v-flex>
						</v-layout>
						<!-- MINI AUDIT -->
						<pui-form-mini-audit class="pl-2" :model="model" v-if="!isCreatingElement"></pui-form-mini-audit>
					</pui-field-set>
				</v-flex>
			</v-layout>

			<!-- Page Footer -->
			<pui-form-footer v-if="!isModalDialog">
				<pui-form-footer-btns
					:formDisabled="formDisabled"
					:saveDisabled="saving"
					:saveAndNew="saveAndNew"
					:saveAndUpdate="saveAndUpdate"
					:save="save"
					:back="back"
				></pui-form-footer-btns>
			</pui-form-footer>
		</v-form>
		<pui-form-loading v-else></pui-form-loading>
	</div>
</template>

<script>
import {PuiFormMethodsMixin} from '@Pui9Components';
import mgrupoenvasadoActions from './MgrupoenvasadoActions';
import mgrupoenvasadoModals from './MgrupoenvasadoModals.vue';

export default {
	name: 'mgrupoenvasado-form',
	mixins: [PuiFormMethodsMixin],
	components: {
		'mgrupoenvasado-modals': mgrupoenvasadoModals
	},
	data() {
		return {
			modelName: 'mgrupoenvasado',
			actions: mgrupoenvasadoActions.formActions
		};
	},
	methods: {
		afterGetData() {
			// Do something after get data from server
		}
	},
	computed: {
		getTitleDatos() {
			return this.$t('form.mgrupoenvasado');
		}
	},
	created() {}
};
</script>
